import { render } from "./MaterialListing.vue?vue&type=template&id=6ecbff8d&scoped=true"
import script from "./MaterialListing.vue?vue&type=script&lang=js"
export * from "./MaterialListing.vue?vue&type=script&lang=js"

import "./MaterialListing.vue?vue&type=style&index=0&id=6ecbff8d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s576427\\Supplemental\\Supplemental UI\\suppl-material-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ecbff8d"]])

export default __exports__